module.exports = function getFetchHeaders() {
	let headers = null;
	if (process.env.BASIC_AUTH_USERNAME && process.env.BASIC_AUTH_PASSWORD) {
		if (typeof btoa !== "undefined") {
			const userName = process.env.BASIC_AUTH_USERNAME;
			const pass = process.env.BASIC_AUTH_PASSWORD;
			headers = {
				Authorization: `Basic ${btoa(`${userName}:${pass}`)}`,
			};
		} else {
			headers = {
				Authorization: `Basic ${Buffer.from(
					`${process.env.BASIC_AUTH_USERNAME}:${process.env.BASIC_AUTH_PASSWORD}`,
					"utf-8"
				).toString("base64")}`,
			};
		}
	}

	return headers;
};
